module.exports = __webpack_public_path__ + "img/pluto.be5030ca.webp";